import { isClient, isIOS } from '@vueuse/core'

export const isFirefox = (): boolean =>
  isClient && /firefox/i.test(window.navigator.userAgent)

export const isSafari = (): boolean =>
  isClient &&
  /safari/i.test(window.navigator.userAgent) &&
  !/chrome/i.test(window.navigator.userAgent)

export { isClient, isIOS }
